import { useState, useEffect, useCallback } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { deleteSalesTeam } from '@user/store/salesTeam/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'

export const useDeleteSalesTeam = () => {
  const dispatch = useAppDispatch()

  const [id, setId] = useState<string>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const executeDelete = useCallback(
    (newId: string) => {
      if (status != 'pending') setId(newId)
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    if (id) {
      const execute = async () => {
        try {
          const result = await dispatch(deleteSalesTeam(id))

          if (mounted) {
            unwrapResult(result)
            setStatus('success')
            toast.success('Sales Team deleted.')
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            toast.error(error.Message)
          }
        } finally {
          setId(undefined)
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [dispatch, id])

  return executeDelete
}
